import React, { useContext, useState } from 'react'
import * as Component from './LocalisationBox.styles'
import { string } from 'prop-types'
import { Icon, LocalisationButton } from 'components/atoms'

// helpers
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { useLocalisation } from 'hooks/useLocalisation'

const LocalisationBox = ({ className = '', ...other }) => {
  const [visibility, setVisibility] = useState(true)
  const textContext = useContext(TextContext)
  const { clientID: clientID, clientName: clientName } = useLocalisation()

  return (
    <>
      {visibility && !clientID && (
        <Component.LocalisationContainer
          other={ other }
          className={ `container-content-brand ${ className }` }
          client={ clientID }
          { ...other }>
          <button
            id='close-localisation-dialog-btn'
            className={ 'localisation-close-button' }
            onClick={ () => setVisibility(!visibility) }>
            <Icon className='icon-f-cross close-icon' />
            <span className='sr-only'>
              {textContext['localization.button.close']}
            </span>
          </button>
          <h4 className={ 'h5 localization-title' }>
            {textContext['localization.title']}
          </h4>
          <div>
            <div className={ 'no-location-container' }>
              <Icon className='icon-f-map-marker localization-marker' />
              <p className={ 'no-location-copy' }>
                {textContext['localization.copy.noLocation']}
              </p>
            </div>
            <LocalisationButton />
          </div>
        </Component.LocalisationContainer>
      )}
      {visibility && clientID && (
        <Component.LocalisationContainer
          other={ other }
          className={ `container-content-brand ${ className }` }
          client={ clientID }
          { ...other }>
          <div className={ 'has-location-container' }>
            <p className={ 'has-location-copy' }>
              {textContext['localization.copy.hasLocation']}{' '}
              <span className={ 'client-name' }>{clientName}</span>
            </p>
          </div>
        </Component.LocalisationContainer>
      )}
    </>
  )
}

LocalisationBox.propTypes = {
  className: string,
}

export default LocalisationBox
